<main class="session-expired" data-test-id="sessionExpiredMainContainer">
  <img
    data-test-id="sessionExpiredImage"
    alt="Session expired"
    [src]="config.image"
  />

  <h1 class="session-expired__title" data-test-id="sessionExpiredTitle">
    {{ config.title }}
  </h1>

  <p
    class="session-expired__subtitle"
    data-test-id="sessionExpiredSubtitle"
    [innerHTML]="contentBody"
  ></p>

  <div class="button__group">
    <zip-button
      data-test-id="sessionExpiredGoToLoginButton"
      level="high"
      content="{{ config.loginButton.content }}"
      (zipButtonClicked)="handleLogin()"
    ></zip-button>
  </div>
</main>
